export const convertTotalPriceToPoints = (totalPrice = 0, pointsConvertFactor = 0) =>
  Math.floor(totalPrice * pointsConvertFactor);

export const canShowPoints = (userAuthenticated, pointsOfOrder, loyaltyExperienceEnabled) =>
  userAuthenticated && pointsOfOrder && loyaltyExperienceEnabled;

const calculateItemPoints = item => {
  // TODO: Delete this line when backend upgrade loyalty in prod.
  const loyaltyMultiplier = item?.loyaltyMultiplier || 1;
  return loyaltyMultiplier * item?.total || 0;
};

const isNotGiftCard = item => !(!!item?.isGiftCard && item?.isGiftCard);

export const getCouponsTotal = shoppingCart =>
  shoppingCart?.appliedPromos?.reduce((acc, coupon) => acc + coupon?.appliedCoupon?.value, 0);

export const calculatePointsOfProducts = (shoppingCart, pointsConvertFactor = 1) =>
  Math.floor(
    (shoppingCart?.items
      ?.filter(item => isNotGiftCard(item))
      .reduce((acc, item) => acc + calculateItemPoints(item), 0) - getCouponsTotal(shoppingCart) || 0) *
      pointsConvertFactor
  );

export const anItemHasMultiplier = (shoppingCartItems = []) =>
  shoppingCartItems.some(item => item?.loyaltyMultiplier > 1);
